import { html } from 'lit'

import { FieldRenderer } from '../types'

export const OxGristRendererTextarea: FieldRenderer = (value, column, record, rowIndex, field) => {
  return html`<span style="height:auto;white-space: pre-wrap;word-wrap:break-word;">${value}&nbsp;</span>`
}
